import JotformPage from "@components/Jotform/JotformPage";
import getFormId from "@utils/forms";
import { useCurrentUserMutation } from "@utils/hooks";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

type FactFindProps = {};

const FactFindRiskReward: React.FC<FactFindProps> = () => {
  // const [user] = useAuthState(auth);
  // const queryClient = useQueryClient();
  // const ref = doc(collection(db, "users"), user?.uid || "a");
  // const { isSuccess, mutate } = useFirestoreDocumentMutation(ref, {
  //   merge: true,
  // });

  // useEffect(() => {
  //   if (isSuccess) {
  //     queryClient.removeQueries(["users", user?.uid]);
  //   }
  // }, [queryClient, isSuccess, user]);

  const navigate = useNavigate();
  const { mutate, isLoading, isSuccess } = useCurrentUserMutation();

  useEffect(() => {
    if (!isLoading && isSuccess) {
      navigate("/fact-find");
    }
  }, [isSuccess, isLoading, navigate]);

  return (
    <JotformPage
      formId={getFormId("fact_find_risk_reward")}
      onSubmit={() =>
        mutate({
          form_fact_find_risk_reward: true,
        })
      }
    />
  );
};
export default FactFindRiskReward;